module.exports = __webpack_public_path__ + "@/assets/img/logo.a6ab6929.svg";